import Region from './Region';
import RegionFactory from './RegionFactory';
import DomainRegistry from '@/creditflowresearch/domain/DomainRegistry';

DomainRegistry.register(async (container, data) => {
  if (data?.regions?.length) {
    Region.initialize(data.regions, RegionFactory.createFromData);
  }
});

export { default } from './Region';
export { default as Region } from './Region';
export { default as RegionFactory } from './RegionFactory';
export { default as UsoaRegion } from './entities/UsoaRegion';
export { default as EmeaRegion } from './entities/EmeaRegion';
export { default as ApacRegion } from './entities/ApacRegion';
export { default as LatmRegion } from './entities/LatmRegion';
export { RegionType, RegionAbbreviations } from './RegionType';
export * from './constants';
